import type { QueryHookResult } from '@change-corgi/core/react/async';
import { useQuery } from '@change-corgi/core/react/async';
import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import type { NewlyCreatedPetition } from '../../types';

import { getNewlyCreatedPetitions } from './api';

type Options = Readonly<{
	petitionSlugOrId?: string;
}>;

type NewlyCreatedPetitionsState = QueryHookResult<
	Readonly<{ petitions: ReadonlyArray<{ node: NewlyCreatedPetition }>; parentPetitionId?: string }>
>;
type Result = ModelHookResult<{
	petitionsState: NewlyCreatedPetitionsState;
}>;

export function useNewlyCreatedPetitions({ petitionSlugOrId }: Options): Result {
	const utilityContext = useUtilityContext();

	return {
		data: {
			petitionsState: useQuery(
				async () => ({
					...(await getNewlyCreatedPetitions({ petitionSlugOrId }, utilityContext)),
				}),
				[petitionSlugOrId, utilityContext],
			),
		},
	};
}
